import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";

export default function Checkbox({ checked, className, style, onChange }) {
  if (!checked) {
    return (
      <MdCheckBoxOutlineBlank
        onClick={() => onChange(!checked)}
        className={className}
        style={{ ...style, cursor: "pointer" }}
      />
    );
  }
  return (
    <MdCheckBox
      onClick={() => onChange(!checked)}
      className={className}
      style={{ ...style, cursor: "pointer" }}
    />
  );
}
